import React, { Component } from 'react';
import { connect } from 'react-redux';
import viewHelper from '../../helpers/view';
import imageHelper from '../../helpers/image';
import ProfileInfo from './profileInfo';
import MemberInfo from '../shared/memberInfo';
import { alerts } from '../../actions/alerts';
import { isUndefined } from 'lodash';

const MAX_IMAGE_SIZE = 6 * 1024 * 1024;

class Profile extends Component {
	constructor(props) {
		super(props);
		this.state = {
			previewImageUrl: null,
			isUploading: false,
			profileImageKey: 0
		};
	}

	componentDidUpdate(prevProps) {
		const prevUrl = prevProps.member.profile_image_url;
		const nextUrl = this.props.member.profile_image_url;

		if (prevUrl !== nextUrl && this.state.previewImageUrl) {
			this.revokePreview();
			this.setState({ previewImageUrl: null });
		} else if (prevProps.member !== this.props.member && nextUrl) {
			this.setState({ profileImageKey: Date.now() });
		}
	}

	componentWillUnmount() {
		this.revokePreview();
	}

	revokePreview() {
		if (this.state.previewImageUrl) {
			URL.revokeObjectURL(this.state.previewImageUrl);
		}
	}

	triggerFileSelect() {
		document.getElementById('profileImageInput').click();
	}

	handleImageChange(e) {
		const file = e.target.files[0];
		e.target.value = '';
		if (!file) return;

		if (file.size > MAX_IMAGE_SIZE) {
			this.props.dispatch(alerts.error('Image file is too large. Please select an image under 6 MB.'));
			return;
		}

		imageHelper.resizeImage(file, imageHelper.PROFILE_IMAGE_SIZE)
			.then((resizedFile) => {
				this.revokePreview();
				const previewUrl = URL.createObjectURL(resizedFile);
				this.setState({ previewImageUrl: previewUrl, isUploading: true });

				const formData = new FormData();
				formData.append('image', resizedFile);
				this.props.updateMember(formData, (success) => {
					this.setState({ isUploading: false });
					if (success) {
						this.props.dispatch(alerts.success('Profile photo updated successfully.'));
					}
				});
			})
			.catch(() => {
				this.props.dispatch(alerts.error('Could not process image. Please try another file.'));
			});
	}

	render() {
		const { member } = this.props;
		const profileImageUrl = this.state.previewImageUrl || member.profile_image_url;

		return (
			<div className="container content">
				<MemberInfo title={viewHelper.getFullName(member)} subtitle={`Member No: ${member.member_no}`} />
				<div className="col-md-2 col-xs-12 col-lg-2 text-center">
					{profileImageUrl && (
						<img
							key={this.state.profileImageKey}
							alt=""
							src={profileImageUrl}
							className="img-circle profile-image"
						/>
					)}
					<button
						className="btn btn-primary btn-sm mt-10"
						onClick={this.triggerFileSelect.bind(this)}
						disabled={this.state.isUploading}
					>
						{this.state.isUploading ? 'Uploading...' : 'Update Image'}
					</button>
					<input type="file" id="profileImageInput" accept="image/*" style={{ display: 'none' }} onChange={this.handleImageChange.bind(this)} />
				</div>
				<div className="col-md-10 col-xs-12 col-lg-10 profile-info mb-15">
					<div className="col-md-6 col-lg-6 col-xs-12 no-padding">
						<ProfileInfo title='Phone Number' icon='fas fa-mobile-alt'     info={viewHelper.getFormattedPrimaryPhone(member)} />
						<ProfileInfo title='Address'      icon="fas fa-map-marker"     info={viewHelper.getFormattedAddress(member)} />
						<ProfileInfo title='Email'        icon="far fa-envelope"       info={member.email} />
						<ProfileInfo title='Birthday'     icon="fas fa-birthday-cake"  info={viewHelper.getBirthday(member)} />
						<ProfileInfo title='Location'     icon="fas fa-location-arrow" info={member.site_name} />
					</div>
					<div className="col-md-6 col-lg-6 col-xs-12 no-padding">
						<ProfileInfo title='Barcode'         icon="fas fa-barcode"  info={member.barcode_no} />
						<ProfileInfo title='Membership Type' icon="fas fa-tag"      info={member.membership_type} />
						<ProfileInfo title='Trainer'         icon="fas fa-dumbbell" info={member.trainer} />
					</div>
				</div>

				{member.qr_code && <div className='col-md-12 col-lg-12 text-center'>
					<div className='w-50'>
						<h5>Use any of the below to checkin</h5>
						<img className='qrcode-image' src={member.qr_code} alt='QrCode' />
					</div>
				</div>}

				{member.barcode_image && <div className='col-md-12 col-lg-12 text-center'>
					<div className='w-50'>
						<h5 className='mb-15'>OR</h5>
						<img className='barcode-image' src={member.barcode_image} alt='barcode' />
					</div>
				</div>}
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	return {
		member: state.member || ownProps.member
	};
}

function mapDispatchToProps(dispatch) {
	return { dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
